import showdown from "showdown";

export default (survey) => {
  //Create showdown markdown converter
  var converter = new showdown.Converter({ openLinksInNewWindow: true });
  survey.onTextMarkdown.add(function (survey, options) {
    //convert the markdown text to html
    var str = converter.makeHtml(options.text);
    //remove root paragraphs <p></p>
    str = str.substring(3);
    str = str.substring(0, str.length - 4);
    //set html
    options.html = str;
  });
};
